export const services = [
  {
    icon: 'fas fa-layer-group',
    title: 'College level courses - for free!',
    subtitle:
      'Our courses and tutorials are built engineers and college Computer Science instructors. They feature beautiful videos supported by engaging exercises.',
  },
  {
    icon: 'fab fa-sketch',
    title: 'Designed with industry',
    subtitle:
      'Make School was founded in Silicon Valley as part of the Y Combinator network. We work with top tech companies to design our curriculum.',
  },
  {
    icon: 'fas fa-code',
    title: 'Real world projects',
    subtitle:
      'Our courses and tutorials are designed around real world projects. We believe the best learning happens when you apply knowledge to a practical goal.',
  },
];

export const courses = [
  {
    icon: 'fas fa-layer-group',
    title: 'CS 1.0: Intro to Computer Science',
    subtitle:
      'Learn the fundamentals of computer science. Explore variables, data types, conditionals, loops, lists, and functions. Learn to write pseudocode, drawing flowchart diagrams, problem solving, and debugging.',
  },
  {
    icon: 'fab fa-sketch',
    title: 'WEB 1.0: Intro to Web Development (coming soon)',
    subtitle:
      'Build simple websites in HTML, CSS, and Javascript. Explore REST, resources, and Model-View-Controller architectures. Learn request-response cycles, server-side templating, testing, and foundational topics.',
  },
  {
    icon: 'fas fa-code',
    title: 'FEW 1.2: JavaScript Fundamentals (coming soon)',
    subtitle:
      'Learn foundational JavaScript to build applications and games. Explore classes and Object Oriented Programming (OOP) and gain a strong understanding of JavaScript syntax and features.',
  },
];

export const partners = [
  {
    name: 'Google',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/t_600x600_fit/v1/ProductCollege/Google_Logo.svg',
  },
  {
    name: 'Facebook',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/t_600x600_fit/v1/Homepage/companies/facebook-wordmark.svg',
  },
  {
    name: 'Microsoft',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/t_600x600_fit/v1/ProductCollege/Microsoft_Logo.svg',
  },
  {
    name: 'LinkedIn',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/t_600x600_fit/v1/ProductCollege/Linkedin_Logo.svg',
  },
  {
    name: 'Spotify',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/v1605369161/Homepage/companies/spotify.svg',
  },
  {
    name: 'Y Combinator',
    logo:
      'https://res.cloudinary.com/makeschool/image/upload/v1537203877/Homepage/companies/ycombinator.svg',
  },
];

export const gallery = [
  {
    image: {
      src:
        'https://res.cloudinary.com/makeschool/image/upload/w_135,f_auto,q_auto/Mediabook/Team/Kathryn.jpg',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src:
        'https://res.cloudinary.com/makeschool/image/upload/w_135,f_auto,q_auto/Mediabook/Team/Ashu.jpg',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src:
        'https://res.cloudinary.com/makeschool/image/upload/w_135,f_auto,q_auto/Mediabook/Team/Rob.jpg',
    },
    title: 'gallery',
    cols: 1,
  },
  {
    image: {
      src:
        'https://res.cloudinary.com/makeschool/image/upload/w_135,f_auto,q_auto/Mediabook/Team/Dion.jpg',
    },
    title: 'gallery',
    cols: 1,
  },
];

export const props = ['Lifetime updates', 'Tech support', 'Tons of assets', 'Integration ready'];

export const users = [
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    name: 'Slack',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    name: 'Mailchimp',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    name: 'Dropbox',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/google-drive.svg',
    name: 'Google Drive',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    name: 'Google Ad Manager',
  },
  {
    logo: 'https://assets.maccarianagency.com/the-front/logos/atlassian.svg',
    name: 'Atlassian',
  },
];

export const pricings = [
  {
    title: 'Standard License',
    subtitle: 'A pay-once license, just for you',
    price: '$49',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
  {
    title: 'Extended License',
    subtitle: 'A pay-once license, just for you',
    price: '$79',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: true,
  },
  {
    title: 'Standard License',
    subtitle: 'A pay-once license, just for you',
    price: '$49',
    priceSuffix: ' / MO',
    features: [
      'Rich, responsive landing pages',
      '100+ styled components',
      'Flexible, simple license',
      'Speedy build tooling',
      '6 months free support included',
    ],
    disclaimer: 'Fully featured 30-day free trial',
    isHighlighted: false,
  },
];

export const faq = [
  {
    id: 'faq-1',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-2',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-3',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-4',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-5',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
  {
    id: 'faq-6',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur.',
    link: 'Check it out',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
